import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import './scss/volt.scss';
import 'react-datetime/css/react-datetime.css';

import HomePage from './pages/HomePage';
import ScrollToTop from './components/ScrollToTop';
import NavigationGuard from './components/NavigationGuard';
import { LoaderProvider } from './components/GlobalLoader';
import { AlertProvider } from "./components/AlertContext";
const AppWrapper = () => {
  const [isBlocking, setIsBlocking] = useState(true);
  const [allowUnload, setAllowUnload] = useState(true); // controls beforeunload

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!allowUnload && isBlocking) {
        e.preventDefault();
        e.returnValue = ""; // triggers browser default confirmation
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isBlocking, allowUnload]);

  return (
    <>
      <ScrollToTop />
      {/* <NavigationGuard
        isBlocking={isBlocking}
        setIsBlocking={setIsBlocking}
        setAllowUnload={setAllowUnload} // pass it down
      /> */}
      <HomePage />
    </>
  );
};

ReactDOM.render(
  <BrowserRouter>
  <LoaderProvider>
     <AlertProvider>
    <AppWrapper />
    </AlertProvider>
    </LoaderProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

